import { apicall } from "../../services/api";
import { Toastify } from "../../services/toastify/toastifyContainer";
import {
  CAMPAIGN_PROMO,
  CREATE_BIN_BATCH,
  ALL_BINS,
  ERR_PROMO,
  ERR_BINS,
  UPDATE_BIN,
  CREATE_BIN_BATCH_LOADING,
  ALL_BIN_BATCH,
  UPDATE_ERR_BIN,
} from "./actionTypes";
import { setAlert } from "./alert.actions";

export const getAllCampaignPromo = () => async (dispatch) => {
  try {
    const res = await apicall(`api/v1/campaign_promo/campaigns/all/`, "get");
    dispatch({
      type: CAMPAIGN_PROMO,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: ERR_PROMO,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    dispatch(setAlert("Unable to fetch data", "error"));
  }
};

export const getAllBinBatch = () => async (dispatch) => {
  try {
    const res = await apicall(`api/v1/campaign_promo/campaigns/clients`, "get");
    dispatch({
      type: ALL_BIN_BATCH,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: ERR_BINS,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    dispatch(setAlert("Unable to fetch data", "error"));
  }
};

export const getAllBins = (campaign_bin_id) => async (dispatch) => {
  try {
    const res = await apicall(
      `api/v1/campaign_promo/${campaign_bin_id}/bins`,
      "get"
    );
    dispatch({
      type: ALL_BINS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: ERR_BINS,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    dispatch(setAlert("Unable to fetch data", "error"));
  }
};

export const createBinBatch = (formData) => async (dispatch) => {
  try {
    // Dispatch loading state
    dispatch({ type: CREATE_BIN_BATCH_LOADING });

    const res = await apicall(
      "api/v1/campaign_promo/createBin",
      "post",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    dispatch({
      type: CREATE_BIN_BATCH,
      payload: res.data.data,
    });
    dispatch(getAllBinBatch());
    localStorage.removeItem("loading");
    dispatch(setAlert(res.data.message, "success"));
  } catch (err) {
    localStorage.removeItem("loading");
    dispatch({
      type: ERR_BINS,
      payload: { msg: err.response.data.msg, status: err.response.status },
    });
    dispatch(setAlert(err.response.data.msg, "error"));
  }
};

export const updateBin = (BinArr) => async (dispatch) => {
  try {
    let { campaign_id, bin, campaign_name, network, ...newBinArr } = BinArr;
    const binData = {
      campaign_id,
      bin,
      campaign_name,
      network,
    };

    const res = await apicall(
      `api/v1/campaign_promo/bin/${newBinArr?.updateId}`,
      "patch",
      binData
    );

    dispatch({ type: UPDATE_BIN, payload: res.data });
    Toastify({ data: "success", msg: res.data.message });
    return res?.data;
  } catch (err) {
    dispatch({
      type: UPDATE_ERR_BIN,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    Toastify({ data: "error", msg: err.response.statusText });
  }
};
